import { Box, ButtonProps } from '@mui/material';
import { keyframes, styled } from '@mui/system';

const slideIn = keyframes`
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(-100%);
    opacity: 0;
  }
`;

interface IAnimatedButtonProps extends ButtonProps {
  open: boolean;
  onClick: () => void;
}

const StyledBox = styled(Box)<IAnimatedButtonProps>(({ open }) => ({
  animation: `${open ? slideIn : slideOut} 0.5s ease forwards`,
}));

const AnimatedButton = ({ open, onClick, children }: IAnimatedButtonProps) => (
  <StyledBox open={open} onClick={onClick}>
    {children}
  </StyledBox>
);

export default AnimatedButton;
